import { useMemo } from "react";

import { useGetEmployeesNameByBadgeNoQuery } from "shared/queries/employee/employee.generated";
import { truncateEmployeeName } from "utils/formats";

type ClaimerNameProps = {
  badgeNo: string | undefined;
  claimerIds: string[];
  skip: boolean;
};

export function useSharedListClaimerName({ badgeNo, claimerIds, skip }: ClaimerNameProps) {
  const { data } = useGetEmployeesNameByBadgeNoQuery({
    skip,
    variables: {
      input: {
        badgeNumbers: claimerIds,
      },
    },
    notifyOnNetworkStatusChange: true,
  });

  const otherEmployeeName = useMemo(() => {
    if (!data?.getEmployees) return "";

    const otherEmployee = data.getEmployees.find((employee) => employee.badgeNo !== badgeNo);
    if (!otherEmployee) return "";
    return otherEmployee.displayName
      ? truncateEmployeeName(otherEmployee.displayName)
      : otherEmployee.badgeNo;
  }, [data?.getEmployees, badgeNo]);

  return otherEmployeeName;
}
